import { render, staticRenderFns } from "./SuppliesDlivyStatus.vue?vue&type=template&id=3bcda8d2&scoped=true&"
import script from "./SuppliesDlivyStatus.vue?vue&type=script&lang=js&"
export * from "./SuppliesDlivyStatus.vue?vue&type=script&lang=js&"
import style0 from "./SuppliesDlivyStatus.vue?vue&type=style&index=0&id=3bcda8d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcda8d2",
  null
  
)

export default component.exports